import { languageConstants } from '../actions/constants/languageConstants';

const languageData = (state = { items: [] }, action: any) => {
	switch (action.type) {
		case languageConstants.LanguageGetByFilterRequest:
			return {
				...state,
				isLoading: true,
				isSuccess: false,
				isError: false
			};
		case languageConstants.LanguageGetByFilterSuccess:
			return {
				...state,
				isLoading: false,
				isSuccess: true,
				isError: false,
				items: action.payload.languages,
			};
		case languageConstants.LanguageGetByFilterFailure:
			return {
				...state,
				isLoading: false,
				isSuccess: false,
				isError: true,
				status: action.payload
			};

		case languageConstants.LanguageDetailRequest:
			return {
				...state,
				isLoading: true,
				isSuccess: false,
				isError: false
			};
		case languageConstants.LanguageDetailSuccess:
			return {
				...state,
				isLoading: false,
				isSuccess: true,
				isError: false,
				item: action.payload.language,
			};
		case languageConstants.LanguageDetailFailure:
			return {
				...state,
				isLoading: false,
				isSuccess: false,
				isError: true,
				status: action.payload
			};

		case languageConstants.LanguageSaveRequest:
			return {
				...state,
				isLoading: true,
				isSuccess: false,
				isError: false
			};
		case languageConstants.LanguageSaveSuccess:
			return {
				...state,
				isLoading: false,
				isSuccess: true,
				isError: false,
				status: action.payload.status,
			};
		case languageConstants.LanguageSaveFailure:
			return {
				...state,
				isLoading: false,
				isSuccess: false,
				isError: true,
				status: action.payload,
			};

		case languageConstants.LanguageUpdateRequest:
			return {
				...state,
				isLoading: true,
				isSuccess: false,
				isError: false
			};
		case languageConstants.LanguageUpdateSuccess:
			return {
				...state,
				isLoading: false,
				isSuccess: true,
				isError: false,
				status: action.payload.status
			};
		case languageConstants.LanguageUpdateFailure:
			return {
				...state,
				isLoading: false,
				isSuccess: false,
				isError: true,
				status:action.payload
			};

		case languageConstants.LanguageDeleteRequest:
			return {
				...state,
				isLoading: true,
				isSuccess: false,
				isError: false,
				isLanguageDeleted: false
			};
		case languageConstants.LanguageDeleteSuccess:
			return {
				...state,
				isLoading: false,
				isSuccess: true,
				isError: false,
				isLanguageDeleted: true,
				status: action.payload.status,
			};
		case languageConstants.LanguageDeleteFailure:
			return {
				...state,
				isLoading: false,
				isSuccess: false,
				isError: true,
				isLanguageDeleted: true,
				status: action.payload
			};
		default:
			return state;
	}
};

export default languageData;